module.exports = __webpack_public_path__ + "static/img/Reed-Mahoney.3e0a665.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Reed-Mahoney.jpg
// module id = cjC+
// module chunks = 0